'use client';

import { useTranslations } from 'next-intl';
import { CheckCircle } from '@phosphor-icons/react';

interface SurveyThankYouProps {
  emailProvided: boolean;
}

export default function SurveyThankYou({ emailProvided }: SurveyThankYouProps) {
  const t = useTranslations('landing.survey.thankYou');

  return (
    <div className="text-center py-12 animate-fade-in">
      <div className="w-16 h-16 bg-teal-50 rounded-full flex items-center justify-center mx-auto mb-6">
        <CheckCircle weight="regular" className="w-8 h-8 text-teal-500" />
      </div>

      {emailProvided ? (
        <>
          <h3 className="font-heading text-2xl font-semibold text-dark mb-3">
            {t('withEmailTitle')}
          </h3>
          <p className="text-gray-600 max-w-md mx-auto leading-relaxed">
            {t('withEmailMessage')}
          </p>
        </>
      ) : (
        <>
          <h3 className="font-heading text-2xl font-semibold text-dark mb-3">
            {t('withoutEmailTitle')}
          </h3>
          <p className="text-gray-600 max-w-md mx-auto leading-relaxed">
            {t('withoutEmailMessage')}
          </p>
        </>
      )}
    </div>
  );
}
